import axios from "axios"
import {getAuthToken} from "utils/msteams"
import {AxiosResponse} from "axios"
import client from "../../utils/clients/apollo"
import {BOT_UNLINK_USER_MUTATION} from "./queries";

interface AuthStartResponse {
  state: string,
  subdomain: string
}

class LinkService {
  async start(): Promise<AuthStartResponse> {
    const adToken = await getAuthToken()
    const res = await axios.post<any, AxiosResponse<AuthStartResponse>>("/api/v1/auth-start", {token: adToken})

    return res.data
  }

  async botUnlinkUser(userId: string): Promise<boolean> {
    const res = await client.mutate<{ botUnlinkUser: boolean }>({
      mutation: BOT_UNLINK_USER_MUTATION,
      variables: {
        userId: userId,
        type: "MICROSOFT_TEAMS"
      }
    })

    return res.data?.botUnlinkUser!
  }
}

const botService = new LinkService()

export default botService
